// AssignmentContent.jsx

import ContentDataTable from "../../components/ContentDataTable/ContentDataTable";

const AssignmentContent = () => {
  return (
    <ContentDataTable
      title="Assignment Contents"
      apiEndpoint="/pinging-assignment-content"
      defaultValue="all"
    />
  );
};

export default AssignmentContent;
